import { Container } from 'react-bootstrap';
import { FC } from 'react';
import { generalBlue } from 'src/app-config';
import { generalHthHelper } from '@monorepo/helpers';
import { HTHDoNotCalls } from './HTHSectionFaceDoNotCalls';
import { HTHFaceBuildings } from './HTHSectionFaceBuildings';
import { HTHFaceDeleteButton } from './HTHSectionFaceDeleteButton';
import { HTHObservations } from './HTHSectionFaceObservations';
import { typeHTHTerritory, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetConfig, useGetCurrentUser, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace | null;
    hthTerritory: typeHTHTerritory;
    territoryNumber: typeTerritoryNumber;
};

export const HTHFace: FC<propsType> = ({ currentFace, hthTerritory, territoryNumber }) => {
    const config = useGetConfig();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const user = useGetCurrentUser();

    return (
        <Container className={isDarkMode ? 'bg-dark text-white' : ''}
            style={{ paddingBottom: isMobile ? '1px' : '30px' }}
        >
            <h1 className={'text-white py-3 mb-4'}
                style={{
                    backgroundColor: generalBlue,
                    fontSize: isMobile ? '2.3rem' : '2.8rem',
                    fontWeight: 'bolder',
                    margin: isMobile ? '30px auto 20px auto' : '60px auto 40px auto',
                    textAlign: 'center'
                }}
            >
                <span>TERRITORIO {territoryNumber}</span>
                {currentFace &&
                    <>
                    <br />
                    <span>Manzana {generalHthHelper.MaskTheBlock(currentFace.block, config.isUsingLettersForBlocks)}</span>
                    <br />
                    <span>Cara {generalHthHelper.MaskTheFace(currentFace.face, config.isUsingLettersForBlocks)} - {currentFace.street}</span>
                    </>
                }
            </h1>
            {hthTerritory && currentFace &&
                <>
                <HTHFaceBuildings
                    currentFace={currentFace}
                    territoryNumber={hthTerritory.territoryNumber}
                />
                {!config.isDisabledHthFaceObservations &&
                    <HTHObservations
                        currentFace={currentFace}
                        territoryNumber={hthTerritory.territoryNumber}
                    />
                }
                <HTHDoNotCalls
                    currentFace={currentFace}
                    territoryNumber={hthTerritory.territoryNumber}
                />
                {!config.isDisabledEditHthMaps && user.isHthAdmin && !isMobile &&
                    <HTHFaceDeleteButton
                        currentFace={currentFace}
                        hthTerritory={hthTerritory}
                    />
                }
                </>
            }
        </Container>
    );
}
